import { genFormValidationAlertMsg } from 'lib/utils/genFormValidationAlertMsg'
import { z } from 'zod'

export const repApprovalValidationSchema = (data: Record<string, any>) => {
  const validateSchema = z.record(z.string(), z.any()).refine(
    // best for known key values
    () =>
      data.numberOfExpiredHardware === '0' ||
      data.numberOfExpiredHardware === undefined,
    {
      message: genFormValidationAlertMsg({
        path: 'numberOfExpiredHardware',
        context: { numberOfExpiredHardware: data.numberOfExpiredHardware },
      }),
      path: ['numberOfExpiredHardware'],
    }
  )

  return validateSchema.safeParse(data)
}

export const useRepApprovalValidationSchema = () => {
  const guestRepValidationSchema = z
    .object({
      repName: z.string().min(1, 'Rep name is required'),
      repInfo: z.string().min(1, 'Rep name and phone number are required'),
    })
    .superRefine((data, ctx) => {
      if (!data.repInfo) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Guest rep name and phone number are required',
          path: ['repInfo'],
        })
        return
      }

      if (!data.repInfo.includes('/')) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Format must be "Name / Phone Number"',
          path: ['repInfo'],
        })
        return
      }

      const [repName, phoneNumber = ''] = data.repInfo.split('/')

      if (!repName.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Guest rep name is required',
          path: ['repInfo'],
        })
      }

      const cleanedPhone = phoneNumber.trim().replace(/\D/g, '')
      const phoneRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/

      if (cleanedPhone.length !== 10 || !phoneRegex.test(phoneNumber.trim())) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Phone number must be in format: (XXX) XXX-XXXX',
          path: ['repInfo'],
        })
      }
    })

  const repInfoValidationSchema = z
    .object({
      repInfo: z.string().optional(),
    })
    .superRefine((data, ctx) => {
      if (!data.repInfo) return

      if (!data.repInfo.includes('/')) return

      const [, phoneNumber = ''] = data.repInfo.split('/')
      const cleanedPhone = phoneNumber.trim().replace(/\D/g, '')
      const phoneRegex = /^\(\d{3}\)\s\d{3}-\d{4}$/

      if (cleanedPhone.length !== 10 || !phoneRegex.test(phoneNumber.trim())) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Phone number must be in format: (XXX) XXX-XXXX',
          path: ['repInfo'],
        })
      }
    })

  return { repInfoValidationSchema, guestRepValidationSchema }
}
